import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_22tswwgnqb: FaireBrandEntity = {
  token: "b_22tswwgnqb",
  type: "brand",
  name: "Emory Park",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ad4454abbeb2403f6ac8c637b31332ff14e1c561ebdf6fbc3a31c94332ff979e/1565214472.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bdb62ed47913db2073f3f09eb64198b18ca9d6b074779a988f8efde6cc1990a8.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ad4454abbeb2403f6ac8c637b31332ff14e1c561ebdf6fbc3a31c94332ff979e/1565214472.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bdb62ed47913db2073f3f09eb64198b18ca9d6b074779a988f8efde6cc1990a8.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 83,
  rating: 4.5,
  reviewCount: 147,
  isInsider: true,
  description:
    "Emory Park is a fresh, emerging new line from the heart of downtown Los Angeles offering carefully designed and curated clothing. We design and supply wholesale young contemporary women`s apparel through our own manufacturing facilities where majority of our products are made in the U.S. Our motif is to design and produce unique and sophisticated clothing that make women feel beautiful.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:35.237Z",
    importedBy: "entity-db-cli",
  },
};
